import AbstractParams from './params.js';


export default class ChartParams extends AbstractParams 
{

	constructor(params) 
	{
		super(params);
	}

}